<template>
  <v-container fluid>
    <v-flex pa-1>
      <v-card>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="person"
              name="from_name"
              v-model="from_name"
              label="Your Name"
              type="text"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="email"
              name="email"
              v-model="email"
              label="Your Email"
              required
              type="text"
            ></v-text-field>
            <v-text-field
              prepend-icon="subject"
              name="subject"
              v-model="subject"
              label="Subject"
              required
              type="text"
            ></v-text-field>
            <v-textarea
              solo
              prepend-icon="message"
              name="message"
              v-model="message"
              label="Message"
              required
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-xs-center">
            <v-btn
              v-if="!emailSent"
              :loading="loading"
              :disabled="loading"
              color="accent"
              @click="loader = 'loading'"
            >SEND MESSAGE
              <v-icon right dark>mail</v-icon>
              <span slot="loader" class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </v-btn>
            <v-btn v-else color="success" @click="submit">MESSAGE SENT
              <v-icon right dark>check_circle</v-icon>
            </v-btn>
          </div>
          <!-- <test> -->
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import * as emailjs from 'emailjs-com';

export default {
  name: 'ContactForm',
  data() {
    return {
      from_name: null,
      message: null,
      subject: null,
      email: null,
      emailSent: false,
      loader: null,
      loading: false,
    };
  },
  methods: {
    submit() {
      const templateParams = {
        email: this.email,
        from_name: this.from_name,
        message: this.message,
        subject: this.subject,
      };
      if (
        this.email !== null
        && this.from_name !== null
        && this.message !== null
        && this.subject != null
      ) {
        emailjs.send(
          'default_service',
          'template_ft5RFtI6',
          templateParams,
          'user_rViWDW3Ck89GREdYxfE8P',
        );
      } else {
        this.formInvalid = true;
      }
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      this.submit();
      // eslint-disable-next-line
      // eslint-disable-next-line
      setTimeout(() => (this.emailSent = true), 2000);
      this.loader = null;
    },
  },
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
